import React, { useState, useEffect } from 'react';
import Icon from '../../../components/AppIcon';
import { 
  articlesService, 
  citiesService, 
  projectsService, 
  subUnionsService,
  membersService 
} from '../../../services/dataService';

const MetricsCard = ({ title, icon, color, className = '' }) => {
  const [value, setValue] = useState('--');
  const [change, setChange] = useState('--');
  const [changeType, setChangeType] = useState('neutral');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchMetrics = async () => {
      try {
        setLoading(true);
        let count = 0;
        
        // Determine which service to call based on title
        if (title?.includes('الاتحادات الفرعية') || title?.includes('Sub Unions')) {
          const data = await subUnionsService?.getAll();
          count = data?.length || 0;
        } else if (title?.includes('المقالات') || title?.includes('Articles')) {
          const data = await articlesService?.getAll();
          count = data?.filter(article => article?.published)?.length || 0;
        } else if (title?.includes('المشاريع') || title?.includes('Projects')) {
          const data = await projectsService?.getAll();
          count = data?.filter(project => project?.status === 'ongoing')?.length || 0;
        } else if (title?.includes('المدن') || title?.includes('Cities')) {
          const data = await citiesService?.getAll();
          count = data?.length || 0;
        } else if (title?.includes('الأعضاء') || title?.includes('Members')) {
          const data = await membersService?.getAll();
          count = data?.length || 0;
        }

        setValue(count?.toString());
        
        // Calculate change (simplified - you could implement actual change tracking)
        const changeValue = Math.floor(Math.random() * 5); // Random for demo
        setChange(changeValue > 0 ? `+${changeValue}` : '0');
        setChangeType(changeValue > 0 ? 'positive' : 'neutral');
        
      } catch (error) {
        console.error('Error fetching metrics:', error);
        setValue('خطأ');
        setChange('--');
        setChangeType('neutral');
      } finally {
        setLoading(false);
      }
    };

    fetchMetrics();
  }, [title]);

  const getColorClasses = () => {
    switch (color) {
      case 'primary':
        return 'bg-primary/10 text-primary border-primary/20';
      case 'success':
        return 'bg-success/10 text-success border-success/20';
      case 'warning':
        return 'bg-warning/10 text-warning border-warning/20';
      case 'error':
        return 'bg-error/10 text-error border-error/20';
      case 'secondary':
        return 'bg-secondary/10 text-secondary border-secondary/20';
      default:
        return 'bg-muted/10 text-muted-foreground border-muted/20';
    }
  };

  const getChangeColorClasses = () => {
    switch (changeType) {
      case 'positive':
        return 'text-success bg-success/10';
      case 'negative':
        return 'text-error bg-error/10';
      default:
        return 'text-muted-foreground bg-muted/10';
    }
  };

  return (
    <div className={`bg-card border border-border rounded-xl p-6 shadow-elevation-1 hover:shadow-elevation-2 transition-all duration-200 ${className}`}>
      <div className="flex items-start justify-between">
        <div className="flex-1">
          <p className="text-sm font-medium text-muted-foreground font-caption mb-2">
            {title}
          </p>
          
          <div className="flex items-baseline space-x-2 rtl:space-x-reverse mb-4">
            {loading ? (
              <div className="animate-pulse">
                <div className="h-8 w-16 bg-muted rounded"></div>
              </div>
            ) : (
              <h3 className="text-2xl font-bold text-foreground font-heading">
                {value}
              </h3>
            )}
            
            {!loading && change !== '--' && change !== '0' && (
              <span className={`text-xs font-medium px-2 py-1 rounded-full ${getChangeColorClasses()}`}>
                {change}
              </span>
            )}
          </div>
          
          {!loading && changeType === 'positive' && (
            <div className="flex items-center space-x-1 rtl:space-x-reverse text-xs text-success">
              <Icon name="TrendingUp" size={12} />
              <span>نمو إيجابي</span>
            </div>
          )}
        </div>
        
        <div className={`p-3 rounded-lg border ${getColorClasses()}`}>
          {loading ? (
            <div className="animate-pulse">
              <div className="w-6 h-6 bg-muted rounded"></div>
            </div>
          ) : (
            <Icon 
              name={icon} 
              size={24}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default MetricsCard;